




















import { Component, Vue, Prop } from 'vue-property-decorator';
import PersonData from '@/ts/PersonData';

@Component
export default class Participant extends Vue {
    @Prop() public userId!: number;
    @Prop() public deleteEnabled!: boolean;

    constructor() {
        super();
    }

    get showDeleteButton() {
        return this.deleteEnabled && this.$store.getters['User/getUserId'] !== this.userId;
    }

    get dataLoaded(): boolean {
        return (this.userId !== null);
    }

    get role(): string {
        if (this.user.role) {
            return this.user.role.name;
        }

        return '';
    }

    get user(): PersonData {
        return this.$store.getters['User/getCacheUser'](this.userId);
    }

    private removeParticipant(): void {
        // this.$store.dispatch(Actions.REMOVE_PERSON_FROM_CONVERSATION, this.userId);
    }
}
